export default "__VITE_ASSET__3cec4ebe__"